import { logError } from "../utils/log";
import { actionsInterpreter } from "./actionsInterpreter";
import { getErrorMessage } from "./getErrorMessage";
import { RuleAction } from "./RuleAction";
import { ActionReportType, ActionsReport } from "./sendActionsReport";

/**
 *
 * @param domainRules set of rules to execute for the matched domain
 */
export const executeRulesForMatchedDomain = async (
  domainRules: Array<RuleAction>
): Promise<ActionsReport> => {
  const actionsReport: ActionsReport = {
    processingTime: 0,
    url: window.location.href ?? undefined,
    actions: [],
    type: ActionReportType.DIRECT_DOMAIN_MAP,
    errors: [],
  };

  try {
    const startTime = new Date().valueOf();
    actionsReport.actions = await actionsInterpreter(domainRules);
    actionsReport.processingTime = new Date().valueOf() - startTime;
  } catch (error) {
    logError("Error executing rules for matched domain", error);
    actionsReport.errors.push(getErrorMessage(error));
  }

  return actionsReport;
};
